// Labels for server status rows. Pure; no status math here.
export function unitShort(kind, t) {
  return kind === 'km' ? t('maintenancePlans.unitShortKm', 'km') : kind === 'hours' ? t('maintenancePlans.unitShortHours', 'h') : t('maintenancePlans.unitShortDays', 'd');
}
export function statusLabel(status, t) {
  const map = { ok: ['statusOk', 'On track'], dueSoon: ['statusDueSoon', 'Due soon'], overdue: ['statusOverdue', 'Overdue'], noReading: ['statusNoReading', 'No reading'] };
  const [k, d] = map[status] ?? map.noReading;
  return t(`maintenancePlans.${k}`, d);
}
export function remainingText(row, t) {
  const trig = row.driver ? row.triggers.find((x) => x.kind === row.driver) : null;
  if (!trig || trig.remaining === null || trig.remaining === undefined) return t('maintenancePlans.statusNoReading', 'No reading');
  const value = Math.abs(trig.remaining).toLocaleString();
  const unit = unitShort(trig.kind, t);
  return trig.remaining <= 0 ? t('maintenancePlans.overdueBy', '{{value}} {{unit}} overdue', { value, unit }) : t('maintenancePlans.left', '{{value}} {{unit}} left', { value, unit });
}
/** Hover hint for a status badge: a counter below the last-serviced value wins over the plain no-reading hint. */
export function statusHint(row, t) {
  if ((row.triggers ?? []).some((x) => x.belowBaseline)) return t('maintenancePlans.belowBaselineHint', 'The reading is below the last-serviced value. Set the last service again.');
  return row.status === 'noReading' ? t('maintenancePlans.noReadingHint', 'No odometer or engine-hours reading yet') : undefined;
}
